module.exports = __webpack_public_path__ + "img/triangle_down.7ea8bd80.svg";